/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SearchBar_viewer = {
    readonly isSuggestionsFeatureEnabled: boolean | null;
    readonly searchSuggestions?: {
        readonly suggestions: ReadonlyArray<{
            readonly type: string | null;
            readonly terms: ReadonlyArray<{
                readonly term: string | null;
                readonly urlLabel: string | null;
            } | null> | null;
        } | null> | null;
    } | null;
    readonly user?: {
        readonly recentHistoryItems?: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly contemporaryTrackingString: string;
                    readonly firstPhotoWebPath: string | null;
                    readonly pdpURL: string | null;
                    readonly title: string | null;
                    readonly browseUrl: string | null;
                    readonly categoryCode: string | null;
                    readonly serviceId: string | null;
                    readonly categoryPath: string | null;
                    readonly seller: {
                        readonly serviceId: string | null;
                    } | null;
                } | null;
            } | null> | null;
        } | null;
    } | null;
    readonly " $refType": "SearchBar_viewer";
};
export type SearchBar_viewer$data = SearchBar_viewer;
export type SearchBar_viewer$key = {
    readonly " $data"?: SearchBar_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SearchBar_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "SearchBar_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "query",
      "type": "String!",
      "defaultValue": ""
    },
    {
      "kind": "LocalArgument",
      "name": "hasQuery",
      "type": "Boolean!",
      "defaultValue": false
    },
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUserRecentHistoryItem",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "localRecentHistoryItemIds",
      "type": "[String]"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isSuggestionsFeatureEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "SEARCH_BAR_SUGGESTIONS"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"SEARCH_BAR_SUGGESTIONS\")"
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasQuery",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "searchSuggestions",
          "storageKey": null,
          "args": [
            {
              "kind": "Literal",
              "name": "includeTypes",
              "value": [
                "POPULAR",
                "CATEGORY",
                "SELLER"
              ]
            },
            {
              "kind": "Variable",
              "name": "query",
              "variableName": "query"
            }
          ],
          "concreteType": "SearchSuggestion",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "suggestions",
              "storageKey": null,
              "args": null,
              "concreteType": "SearchSuggestionList",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "type",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "terms",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "SearchSuggestionTerm",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "term",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "urlLabel",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "plural": false,
          "selections": [
            {
              "kind": "Condition",
              "passingValue": true,
              "condition": "fetchUserRecentHistoryItem",
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": "recentHistoryItems",
                  "name": "__getRecentHistory_recentHistoryItems_connection",
                  "storageKey": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "excludeItemPks",
                      "variableName": "localRecentHistoryItemIds"
                    }
                  ],
                  "concreteType": "RecentHistoryItemsConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "RecentHistoryItemsEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "Item",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "contemporaryTrackingString",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "firstPhotoWebPath",
                              "args": [
                                {
                                  "kind": "Literal",
                                  "name": "size",
                                  "value": "small"
                                }
                              ],
                              "storageKey": "firstPhotoWebPath(size:\"small\")"
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "pdpURL",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "title",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "browseUrl",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "categoryCode",
                              "args": null,
                              "storageKey": null
                            },
                            (v0/*: any*/),
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "categoryPath",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "seller",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "Seller",
                              "plural": false,
                              "selections": [
                                (v0/*: any*/)
                              ]
                            },
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "__typename",
                              "args": null,
                              "storageKey": null
                            }
                          ]
                        },
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "cursor",
                          "args": null,
                          "storageKey": null
                        }
                      ]
                    },
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "pageInfo",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "PageInfo",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "endCursor",
                          "args": null,
                          "storageKey": null
                        },
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "hasNextPage",
                          "args": null,
                          "storageKey": null
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'd8d46742d0bae1d1c2bb4068680a9e0a';
export default node;
